import { DRPHeader } from "@inputs/date/DateRangePicker/headers";
import { useDRYPHeader } from "./logics";

export const DRYPHeader = () => {
  const props = useDRYPHeader();

  return <DRPHeader {...props} placeholder="aaaa" mask="0000" labelStart="De" labelEnd="A" />;
};
